const entryStyle = {
  row: {
    animation: 'fadeIn 1s'
  },
  checkbox: {
    width: '20px',
    height: '20px',
    borderRadius: '4px'
  },
  actions: {
    '& > *': {
      display: 'none !important',
      '@media (min-width: 768px)': {
        display: 'block !important'
      },
      '&:last-child': {
        display: 'block !important'
      }
    }
  },
  action: {
    width: '40px',
    height: '40px',
    borderRadius: '5px',
    display: 'block',
    marginLeft: 'auto'
  },
  status: {
    width: '70px'
  },
  works: {
    width: '80px'
  },
  pupils: {
    width: '80px'
  },
  worksBone: {
    width: '20px'
  },
  dateBone: {
    width: '86px'
  },
  pupilsBone: {
    width: '20px'
  },
  thumbnail: {
    display: 'none',
    '@media (min-width: 541px)': {
      display: 'block'
    }
  },
  '@keyframes fadeIn': {
    from: { opacity: '0' },
    to: { opacity: '1' }
  }
}

const skeletonStyle = {
  '@keyframes fadeIn': {
    from: { opacity: '0' },
    to: { opacity: '1' }
  }
}

export { entryStyle, skeletonStyle }
